/**
 * CursorGlow — a subtle gold radial spotlight that follows the cursor on
 * desktop.  Disabled on touch devices (no hover).  Pure CSS-positioned
 * absolute element — z-index 0 sits behind form content.
 */
import React, { useEffect, useRef } from 'react';

export function CursorGlow({ isLight }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return undefined;
    let raf = null;
    const onMove = (e) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        el.style.setProperty('--gx', `${e.clientX}px`);
        el.style.setProperty('--gy', `${e.clientY}px`);
      });
    };
    window.addEventListener('mousemove', onMove);
    return () => {
      window.removeEventListener('mousemove', onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none fixed inset-0 z-0 transition-opacity duration-500"
      style={{
        background: isLight
          ? 'radial-gradient(280px circle at var(--gx, 50%) var(--gy, 50%), rgba(245,158,11,0.18), transparent 60%)'
          : 'radial-gradient(360px circle at var(--gx, 50%) var(--gy, 50%), rgba(245,158,11,0.10), transparent 60%)',
        '--gx': '50%',
        '--gy': '50%',
        mixBlendMode: isLight ? 'multiply' : 'screen',
      }}
    />
  );
}
